import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v1"] = "v1";
    ApiVersion["v2"] = "v2";
})(ApiVersion || (ApiVersion = {}));
class UrlBase {
    /**
     * Get base url for notes services calls for specific api version
     * @param version - v1 or v2
     * @returns string - base url for notes services call
     */
    static getBaseUrl(version) {
        return `/api/notes/${version}`;
    }
}

class CommentsService {
    /**
     * constructor for NotesService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Returns notes count
     * @param entityIdList - list of ids to retrieve notes counts
     * @returns CommentCountV1Dto[]
     */
    getNotesCount(entityIdList) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}/comments/search`;
        return this.httpClient
            .post(url, entityIdList)
            .pipe(map(response => response.data));
    }
    /**
     * Gets notes
     * @param entityId - id of the entity
     * @returns CommentV1Dto[]
     */
    getNotes(entityId) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}/comments/${entityId}`;
        return this.httpClient.get(url).pipe(map(response => response.data));
    }
    /**
     * Updates a comment
     * @param commentsListV1Dto - comment to update
     * @returns CommentV1Dto
     */
    updateNotes(commentsListV1Dto) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}/comments`;
        return this.httpClient
            .put(url, commentsListV1Dto)
            .pipe(map(response => response.data));
    }
    /**
     * Adds a comment
     * @param commentsListV1Dto - comment to add
     * @returns CommentV1Dto[]
     */
    addNotes(commentsListV1Dto) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}/comments`;
        return this.httpClient
            .post(url, commentsListV1Dto)
            .pipe(map(response => response.data));
    }
    /**
     * Deletes a note
     * @param noteId - id of the note to delete
     * @returns CommentStatusV1Dto[]
     */
    deleteNote(noteId) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v2)}/comments/${noteId}`;
        return this.httpClient.delete(url).pipe(map(response => response.data));
    }
}
CommentsService.ɵfac = function CommentsService_Factory(t) { return new (t || CommentsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
CommentsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CommentsService_Factory() { return new CommentsService(i0.ɵɵinject(i1.HttpClient)); }, token: CommentsService, providedIn: "root" });
CommentsService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommentsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class NotesServicesModule {
}
NotesServicesModule.ɵfac = function NotesServicesModule_Factory(t) { return new (t || NotesServicesModule)(); };
NotesServicesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NotesServicesModule });
NotesServicesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [CommentsService], imports: [[HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotesServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [HttpClientModule],
                exports: [],
                providers: [CommentsService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotesServicesModule, { imports: function () { return [HttpClientModule]; } }); })();

class CommonJsonResponse {
}

/*
 * Public API Surface of onbalance-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommentsService, CommonJsonResponse, NotesServicesModule };

